import closeIconThin from "./close-thin.svg";
import closeIcon from "./close.svg";
import chevronLeft from "./chevronLeft.svg";
import chevronRight from "./chevronRight.svg";
import cutLine from "./cut-line.svg";
import closeButton from "./close-black.svg";
import playVideo from "./play-video.svg";
import backIcon from "./back.svg";
import playIcon from "./play.svg";
import restartIcon from "./restart.svg";
import zoomInIcon from "./zoom-in.svg";
import zoomOutIcon from "./zoom-out.svg";
import letterAIcon from "./letterA.svg";
import pinchIcon from "./pinch.svg";
import undoIcon from "./undo.svg";
import bringToFront from "./bring-to-front.svg";
import bin from "./bin.svg";
import editBorder from "./edit-border.png";
import editFilters from "./edit-filters.png";
import editFiltersWhite from "./filters-white.svg";
import editStickers from "./edit-stickers.png";
import editText from "./edit-text.png";
import editTextWhite from "./edit-text-white.svg";
import font from "./font.svg";
import fontWhite from "./font-white.svg";
import rotate from "./rotate.svg";
import carouselArrow from "./carousel-arrow.svg";
import cropScale from "./crop-scale.svg";
import cursor from "./cursor.svg";
import colour from "./colour.svg";
import colourWhite from "./colour-white.svg";
import tick from "./tick.svg";
import tickGold from "./tick-gold.svg";

export default {
  closeIconThin,
  closeIcon,
  chevronLeft,
  chevronRight,
  cutLine,
  closeButton,
  playVideo,
  backIcon,
  playIcon,
  restartIcon,
  zoomInIcon,
  zoomOutIcon,
  letterAIcon,
  pinchIcon,
  undoIcon,
  bringToFront,
  bin,
  editBorder,
  editFilters,
  editFiltersWhite,
  editStickers,
  editText,
  editTextWhite,
  font,
  fontWhite,
  rotate,
  carouselArrow,
  cropScale,
  cursor,
  colour,
  colourWhite,
  tick,
  tickGold
};



// WEBPACK FOOTER //
// ./src/imgs/icons/index.js